import React from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import "./TagUsageHistoryComponent.css";
import searchIcon from "../../../../assests/search.svg";
import leftArrow from "../../../../assests/leftArrow.svg";
import LoadingSpinner from "../../../Loading/component";

const TagUsageHistoryComponent = ({
  tagId,
  tagUid,
  loading,
  usageData,
  originalDataLength,
  searchTerm,
  onSearchChange,
  onSearch,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onDateFilter,
  onClearDateFilter,
  onBackClick,
  isFilterApplied
}) => {

  // Convert UTC to IST and format date (DD MMM YYYY)
  const formatDateToIST = (utcDateString) => {
    if (!utcDateString) return "";
    const date = new Date(utcDateString);
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // Convert UTC to IST and format time (HH:MM AM/PM)
  const formatTimeToIST = (utcDateString) => {
    if (!utcDateString) return "";
    const date = new Date(utcDateString);
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  // Format amount
  const formatAmount = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num)) return "₹0.00";
    const formatted = Math.abs(num).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return num < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  // Get transaction type (debit/credit)
  const getTransactionType = (item) => {
    if (item.transactionType === 'DEBIT' || item.opsType === 'PURCHASE') return 'debit';
    if (item.transactionType === 'CREDIT' || item.opsType === 'REFUND') return 'credit';
    if (item.opsType === 'money_add') return 'credit';
    return item.amount > 0 ? 'credit' : 'debit';
  };

  // Get display text for transaction type
  const getTypeText = (item) => {
    if (item.transactionType === 'DEBIT') return 'Debit';
    if (item.transactionType === 'CREDIT') return 'Credit';
    if (item.opsType === 'PURCHASE') return 'Purchase';
    if (item.opsType === 'REFUND') return 'Refund';
    if (item.opsType === 'money_add') return 'Money Added';
    return item.amount > 0 ? 'Credit' : 'Debit';
  };

  // Get order/description text
  const getOrderText = (item) => {
    if (item.orderId) return item.orderId;
    if (item.transactionId) return `Txn: ${item.transactionId}`;
    if (item.opsType === 'PURCHASE') return 'Purchase Transaction';
    if (item.opsType === 'REFUND') return 'Refund Transaction';
    if (item.opsType === 'money_add') return 'Money Added';
    return 'Transaction';
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="tag-usage-container">
          <Sidebar />

          <div className="tag-usage-content">
            {/* Header */}
            <div className="tag-usage-header">
              <button onClick={onBackClick} className="tag-usage-back-btn">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Tag Usage History</h1>
            </div>

            {/* Search and Filter Section */}
            <div className="tag-usage-search-section">
              <div className="tag-usage-search-bar">
                <input
                  type="text"
                  placeholder="Search By Order ID Or Transaction ID"
                  value={searchTerm}
                  onChange={(e) => onSearchChange(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                  className="tag-usage-search-input"
                />
                <button onClick={onSearch} className="tag-usage-search-btn">
                  <img src={searchIcon} alt="Search" />
                </button>
              </div>

              <div className="tag-usage-date-filter">
                <div className="date-filter-wrapper">
                  <div className="date-input-group">
                    <label>From</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => onStartDateChange(e.target.value)}
                      className="date-input"
                    />
                  </div>
                  <div className="date-input-group">
                    <label>To</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => onEndDateChange(e.target.value)}
                      className="date-input"
                    />
                  </div>
                  <button onClick={onDateFilter} className="apply-date-btn">
                    Apply
                  </button>
                  <button onClick={onClearDateFilter} className="clear-date-btn">
                    Clear
                  </button>
                </div>
              </div>
            </div>

          

            {/* Usage Table */}
            <div className="tag-usage-table-container">
              <table className="tag-usage-table">
                <thead>
                  <tr>
                    <th>Date </th>
                    <th>Time </th>
                    <th>Order</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Current Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {usageData?.length > 0 ? (
                    usageData.map((item, index) => (
                      <tr key={item.transactionId || index}>
                        <td>{formatDateToIST(item.timestamp)}</td>
                        <td>{formatTimeToIST(item.timestamp)}</td>
                        <td>{getOrderText(item)}</td>
                        <td className={getTransactionType(item) === 'debit' ? 'debit-amount' : 'credit-amount'}>
                          {formatAmount(item.amount || 0)}
                        </td>
                        <td>
                          <span className={`transaction-type ${getTransactionType(item)}`}>
                            {getTypeText(item)}
                          </span>
                        </td>
                        <td>{formatAmount(item.finalAmount || item.balance || 0)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="tag-usage-no-results">
                        <div className="tag-no-results-content">
                          <p>No usage history found for this tag</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Showing results count */}
            {originalDataLength > 0 && usageData.length !== originalDataLength && (
              <div className="filter-result-info">
                Showing {usageData.length} of {originalDataLength} transactions
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TagUsageHistoryComponent;